// removed by extract-text-webpack-plugin
module.exports = {"container":"_3TA6TGK7_U3WA_ab0lg33X","indicator":"_36x_1Ss3SG85CjDFxCmNVg","value":"_2zPYOIhtVCZj-rvLwFWWLa","unit":"SheAS7Ub7rewzzcRoT4zU","label":"_1mIoJutITxazxUQeeeqxfM"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/RecoveryPlan/components/ProgressIndicators.mod.css
// module id = 2114
// module chunks = 0